import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSWelcomeData, type EnrollmentHYCSWelcomeSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSWelcomeDataMock: EnrollmentHYCSWelcomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/welcome',
  enrollmentData: {
    applicationId: '305802305',
    firstName: 'Johnathan',
  },
}

export const submitEnrollmentHYCSWelcomeDataMock: EnrollmentHYCSWelcomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/fund-account',
}

export const mockGetEnrollmentHYCSWelcomeData = graphql.mutation('getEnrollmentHYCSWelcomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSWelcomeDataMock } })
})

export const mockSubmitEnrollmentHYCSWelcomeData = graphql.mutation('submitEnrollmentHYCSWelcomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSWelcomeDataMock } })
})

export const mockEnrollmentHYCSWelcome = [mockGetEnrollmentHYCSWelcomeData, mockSubmitEnrollmentHYCSWelcomeData]
